import { ConfigServer } from '@/common/config.server';

export const showGitInfo = (): boolean => {
  const config = ConfigServer();

  return config.ShowGitInfo === 'true';
};

export const getGitBranch = (): string => {
  const config = ConfigServer();

  return config.GitBranch;
};

export const getGitClosestTag = (): string => {
  const config = ConfigServer();

  return config.GitClosestTag;
};
